import { ExpiredBadge, ExpiringBadge} from "../../common/status-badge/StatusBadge";
import { ReactComponent as ArrowUpIcon } from "../../../images/arrow-up.svg";
import { ReactComponent as ArrowDownIcon } from "../../../images/arrow-down.svg";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import { ResidentRowActions } from "./resident-table-row/ResidentTableRowHelper";

export interface ICourseStatusProps {
    isCourseExpiringSoon: boolean
    isCourseExpired: boolean;
    courseExpiredMedsCount: number;
    courseExpiringSoonMedsCount: number,
    uiState:ResidentRowActions,
    onStatusBadgeClicked:(uiState:any)=>void
}

const useStyles = makeStyles({
    expiredIcon: {
          fill: '#D93923',
          paddingLeft: 2
        },
        expiringIcon: {
            fill: '#B7591A',
            paddingLeft: 2
        },
     expandclopaseBadge: {
        display: "flex",
        cursor: "pointer"
     }
  });

export const CourseStatusDisplay = (props: ICourseStatusProps) => {
    var badgeTitle: string = "";
    const classes = useStyles();

    if (props.isCourseExpired) {
         badgeTitle = props.courseExpiredMedsCount === 1 ? props.courseExpiredMedsCount + " med expired" 
            : props.courseExpiredMedsCount + " meds expired";

        return <ExpiredBadge>
            <Box onClick={() =>props.onStatusBadgeClicked(props.uiState)} className={classes.expandclopaseBadge} >
                {badgeTitle}
                {props.uiState === ResidentRowActions.Expand ?<ArrowUpIcon  className={classes.expiredIcon} /> 
                                                             :<ArrowDownIcon  className={classes.expiredIcon}/>}
            </Box>
        </ExpiredBadge>;
    }

    if (props.isCourseExpiringSoon) {
         badgeTitle = props.courseExpiringSoonMedsCount === 1 ? props.courseExpiringSoonMedsCount + " med expiring" 
           : props.courseExpiringSoonMedsCount + " meds expiring";
      
        return <ExpiringBadge>
             <Box  onClick={() =>props.onStatusBadgeClicked(props.uiState)} className={classes.expandclopaseBadge}>
                {badgeTitle} 
                {props.uiState === ResidentRowActions.Expand ?<ArrowUpIcon  className={classes.expiringIcon}/>
                                                             :<ArrowDownIcon  className={classes.expiringIcon}/>}
            </Box>
        </ExpiringBadge>
    }

    return null;
};
